import type { NavigationInput } from "../lib/navigation.types.js";
import type { ParamType } from "./params.types";
import { fromStringParams, type ParamsCache } from "./params.utils.js";

/**
 *
 *
 *
 *
 *
 *
 */
const toParams = (
  url: URL | Location,
  paramString: string,
): [location: URL, params: ParamsCache] => {
  return [new URL(url.href), fromStringParams(paramString)];
};

/**
 *
 *
 *
 *
 *
 *
 *
 */
const findParamFragment = (loc: string, type: ParamType): string | undefined => {
  const hashIndex = loc.indexOf("#");

  /*                                                                    */
  if (type === "hash") {
    if (hashIndex === -1) return undefined;
    return loc.slice(hashIndex + 1);
  }

  /*                                                                                               */
  const searchIndex = loc.indexOf("?");
  if (searchIndex === -1) return undefined;
  return hashIndex !== -1 ? loc.slice(searchIndex + 1, hashIndex) : loc.slice(searchIndex + 1);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const locationToParams = (
  loc: NavigationInput,
  type: ParamType,
  base: Location,
): [location: URL, params: ParamsCache] => {
  /*                                          */
  if (typeof loc !== "string") {
    return toParams(new URL(loc.href), loc[type]);
  }

  /*                                                                  */
  const paramFragment = findParamFragment(loc, type);
  if (paramFragment) {
    return toParams(new URL(loc, base.href), paramFragment);
  }

  /*                                                        */
  if (loc.startsWith("http")) {
    return toParams(new URL(loc), "");
  }

  /*                                                                                  */
  return toParams(new URL(base.href), loc);
};
